import "./style.css";

export const Button = ({ elId = "", text = "", iconSrc = "", aria = "", compact = false, disabled = false, loading = false, onClick = () => {}, classList = "", title = "" }) => {
  const _onClick = () => {
    if (!disabled) onClick();
  };

  return (
    <>
      <button
        id={elId}
        title={title}
        className={`button-component text-uppercase ${text ? "with-text" : ""} ${compact ? "compact" : ""} ${loading ? "loading" : ""} ${disabled ? "btn-disabled" : ""} ${classList}`}
        onClick={_onClick}
        disabled={disabled}>
        <div className="btn-txt-container">{text}</div>

        <div className="btn-icon-container">{iconSrc && <img src={iconSrc} />}</div>
      </button>

      <div className="lds-circle">
        <div></div>
      </div>
    </>
  );
};
